import React from 'react';
import Spline from '@splinetool/react-spline';

const SplitScrollSlide = ({ modelUrl, texts }) => {
    return (
        <div className="flex flex-col lg:flex-row w-full h-screen px-10 lg:px-40">
            {/* Left: Fixed or Sticky 3D model */}
            <div className="w-full lg:w-1/2 h-[40vh] lg:h-screen lg:sticky top-0 flex items-center justify-center bg-transparent z-10">
                <Spline scene={modelUrl} className="w-full h-full !bg-transparent" />
            </div>

            {/* Right: Scrollable text slides */}
            <div className="w-full lg:w-[60%] h-[70%] md:h-screen overflow-y-scroll snap-y snap-mandatory scrollbar-none font-bebas ">
                {texts.map((text, idx) => (
                    <section
                        key={idx}
                        className="snap-start h-screen flex md:items-center justify-center"
                    >
                        <div className="bg-white rounded-xl shadow-lg border border-gray-300 h-[50vh] w-full max-w-full px-5 lg:px-16 flex justify-center items-center text-black text-2xl md:text-4xl leading-relaxed relative tracking-normal">
                            {text}
                            <div className="absolute bottom-4 right-6 text-2xl">↓</div>
                        </div>
                    </section>
                ))}
            </div>
        </div>
    );
};

export default SplitScrollSlide;
